import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ChoiceDialogParams, FcChoiceDialogComponent } from './fc-choice-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class FcChoiceDialogService {
  constructor(private matDialog: MatDialog) {}

  public open({ title, description, options }: ChoiceDialogParams): Promise<string> {
    return this.matDialog.open(FcChoiceDialogComponent, {
      data: { title, description, options },
      disableClose: true
    }).afterClosed()
      .toPromise();
  }

  public close(): void {
    this.matDialog.closeAll();
  }
}
